import { render, staticRenderFns } from "./AddEditCategoryForm.vue?vue&type=template&id=58fc9522"
import script from "./AddEditCategoryForm.vue?vue&type=script&lang=js"
export * from "./AddEditCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports